export const version = "experimental/5.5.0";
//# sourceMappingURL=_version.js.map